import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService } from '../../../../core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';
import { AddressControlComponent } from 'src/app/shared/address-control/address-control.component';
import { Plant } from 'src/app/Models/plant';
import { WarehouseDataDto } from 'src/app/dtos/warehouse-data-dto';

@Component({
  selector: 'warehouses-add',
  templateUrl: './warehouses-add.component.html',
  styleUrls: ['./warehouses-add.component.scss']
})
/** warehouses-add component*/
export class WarehousesAddComponent {
  selectedPlant: Plant;
  id: any;
  form: FormGroup;
  submitted: boolean;
  warehouse: WarehouseDataDto;
  plants: Plant[] = [];
  submitButtonText: string = 'GENERAL.LABELS.CREATE';
  isEditing: boolean;
  @ViewChild("addressControl") addressControl: AddressControlComponent;
  constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private apiService: ApiService,
    private messageService: MessageService, private location: Location) {
    this.id = this.activatedRoute.snapshot.params['id'];

  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: ['', Validators.required]
    });

    if (this.id) {
      this.isEditing = true;
      this.submitButtonText = 'GENERAL.LABELS.EDIT';
      this.apiService.get('api/warehouse/dto/' + this.id).subscribe((data: any) => {
        this.warehouse = data.data;
        this.getPlants();
        this.form = this.formBuilder.group({
          name: [this.warehouse.name, Validators.required]
        });
        this.addressControl.setAddressData(this.warehouse);
        this.addressControl.setLatLong(this.warehouse.lat, this.warehouse.long);
      });

    } else {
      this.getPlants();
    }

  }

  get controls() { return this.form.controls; }

  getPlants() {
    this.apiService.get('api/plant/findAll').subscribe(response => {
      if (response.data) {
        this.plants = response.data;
        if (this.warehouse) {
          this.plants.forEach(item => {
            if (item.id == this.warehouse.plant.id) {
              this.selectedPlant = item;
              return;
            }
          });
          if (!this.selectedPlant) {
            this.selectedPlant = this.plants[0];
          }
        }

      }
    });
  }

  back() {
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;
    let addressControlData = this.addressControl.getAddressData();

    if (this.form.invalid || addressControlData.isInvalid) {
      return;
    }

    if (!this.selectedPlant) {
      this.messageService.error('Error', 'Debes seleccionar una planta');
      return;
    }
    let customer: WarehouseDataDto = this.form.value as WarehouseDataDto;
    let address: WarehouseDataDto = addressControlData.values as WarehouseDataDto;
    let model = Object.assign({}, customer, address);

    model.plant = this.selectedPlant;
    if (!model.intNumber)
      model.intNumber = 0;

    if (this.isEditing) {
      model.id = this.id;
      this.apiService.put('api/warehouse/updateFromDto', model).subscribe((response: any) => {
        if (response.data == 1) {
          this.messageService.success("Exito", "El almacen se ha actualizado exitosamente.");
          this.location.back();
        }
        else
          this.messageService.error("Error", 'El nombre de almacen ya existe');
      }, error => {
        this.messageService.handleError(error);
      });
    }
    else {
      this.apiService.post('api/warehouse/saveFromDto', model).subscribe((response: any) => {
        if (response.data == 1) {
          this.messageService.success("Exito", "El almacen se ha agregado exitosamente.");
          this.location.back();
        }
        else
          this.messageService.error("Error", 'El nombre de almacen ya existe');
      }, error => {
        this.messageService.handleError(error);
      });
    }
  }
}
